import { render, staticRenderFns } from "./IcoMessage.vue?vue&type=template&id=1264bc14&scoped=true&"
var script = {}
import style0 from "./IcoMessage.vue?vue&type=style&index=0&id=1264bc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264bc14",
  null
  
)

export default component.exports